module.exports = __webpack_public_path__ + "904c065319b8ae4aa40be944efb83f30.jpg";